import { toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vShow as _vShow, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-4caa956a")

_pushScopeId("data-v-4caa956a")
const _hoisted_1 = { class: "ui__defectList_main" }
const _hoisted_2 = { class: "ui__defectList_title_left" }
const _hoisted_3 = { class: "ui__defectList_title_right" }
const _hoisted_4 = { class: "ui__defectList_title_all" }
const _hoisted_5 = {
  key: 0,
  class: "ui__defectList_title_normal"
}
const _hoisted_6 = {
  key: 1,
  class: "ui__defectList_title_abnormal"
}
const _hoisted_7 = { class: "ui__defectList_title_icon" }
const _hoisted_8 = { class: "ui__defectList_list" }
const _hoisted_9 = { class: "ui__defectList_list_item_flex" }
const _hoisted_10 = { class: "ui__defectList_list_item_left" }
const _hoisted_11 = { class: "ui__defectList_list_item_right" }
const _hoisted_12 = {
  key: 0,
  class: "text-success"
}
const _hoisted_13 = {
  key: 1,
  class: "text-error"
}
const _hoisted_14 = {
  key: 0,
  class: "ui__defectList_list_item_box"
}
const _hoisted_15 = { key: 0 }
const _hoisted_16 = { key: 1 }
const _hoisted_17 = { class: "ui__defectList_list_item_img_cover" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_bannerModel = _resolveComponent("bannerModel")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", {
      class: "ui__defectList_title",
      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.changeIsShowAllState()))
    }, [
      _createVNode("div", _hoisted_2, _toDisplayString(_ctx.state.listName), 1),
      _createVNode("div", _hoisted_3, [
        _createVNode("div", _hoisted_4, [
          (_ctx.state.listNormalNumber > 0)
            ? (_openBlock(), _createBlock("span", _hoisted_5, [
                _createVNode("img", {
                  class: "ui__defectList_title_defect_icon",
                  src: require('@/assets/image/checkSuccess-icon.png')
                }, null, 8, ["src"]),
                _createTextVNode(" " + _toDisplayString(_ctx.state.listNormalNumber) + "项正常 ", 1)
              ]))
            : _createCommentVNode("", true),
          (_ctx.state.listDefectNumber > 0)
            ? (_openBlock(), _createBlock("span", _hoisted_6, [
                _createVNode("img", {
                  class: "ui__defectList_title_defect_icon",
                  src: require('@/assets/image/checkError-icon.png')
                }, null, 8, ["src"]),
                _createTextVNode(" " + _toDisplayString(_ctx.state.listDefectNumber) + "项需注意 ", 1)
              ]))
            : _createCommentVNode("", true)
        ]),
        _createVNode("div", _hoisted_7, [
          _createVNode("img", {
            src: require('@/assets/image/arrows.png'),
            class: {'ui__isShowAll':_ctx.state.isShowAll}
          }, null, 10, ["src"])
        ])
      ])
    ]),
    _withDirectives(_createVNode("div", _hoisted_8, [
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.defectList, (item) => {
        return (_openBlock(), _createBlock("div", {
          class: "ui__defectList_list_item",
          key: item.checkItemCode
        }, [
          _createVNode("div", _hoisted_9, [
            _createVNode("div", _hoisted_10, _toDisplayString(item.checkItemName), 1),
            _createVNode("div", _hoisted_11, [
              (item.itemDesc === '正常' || item.itemDesc === '无此部件' || item.itemDesc === '受限不可检' ||
                        item.itemDesc === '无事故痕迹'|| item.itemDesc === '无火烧痕迹'|| item.itemDesc === '无泡水痕迹')
                ? (_openBlock(), _createBlock("span", _hoisted_12, " 正常 "))
                : (_openBlock(), _createBlock("span", _hoisted_13, "异常"))
            ])
          ]),
          (item.itemDesc !== '正常')
            ? (_openBlock(), _createBlock("div", _hoisted_14, [
                (item.itemDesc === '无此部件' || item.itemDesc === '受限不可检')
                  ? (_openBlock(), _createBlock("span", _hoisted_15, _toDisplayString(item.itemDesc), 1))
                  : (_openBlock(), _createBlock("span", _hoisted_16, [
                      _createVNode("pre", null, _toDisplayString(_ctx.handleSignStatus(item.signRuleVOS)), 1)
                    ]))
              ]))
            : _createCommentVNode("", true),
          (item.photoList && item.photoList.length > 0)
            ? (_openBlock(), _createBlock("div", {
                key: 1,
                class: "ui__defectList_list_item_bottom",
                onClick: ($event: any) => (_ctx.showItemPhoto(item))
              }, [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(item.photoList.slice(0,4), (itemp, index) => {
                  return (_openBlock(), _createBlock("div", {
                    class: "ui__defectList_list_item_img",
                    key: itemp.photoIdStr
                  }, [
                    (index < 2)
                      ? (_openBlock(), _createBlock("img", {
                          key: 0,
                          src: itemp.smallPhotoUrl ? itemp.smallPhotoUrl : itemp.photoPath
                        }, null, 8, ["src"]))
                      : _createCommentVNode("", true),
                    (index === 2)
                      ? (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                          _createVNode("img", {
                            src: itemp.smallPhotoUrl
                          }, null, 8, ["src"]),
                          _createVNode("div", _hoisted_17, [
                            _createVNode("h6", null, _toDisplayString(item.photoList.length) + "张", 1)
                          ])
                        ], 64))
                      : _createCommentVNode("", true)
                  ]))
                }), 128))
              ], 8, ["onClick"]))
            : _createCommentVNode("", true)
        ]))
      }), 128))
    ], 512), [
      [_vShow, _ctx.state.isShowAll]
    ]),
    (_ctx.state.isShowModel)
      ? (_openBlock(), _createBlock(_component_bannerModel, {
          key: 0,
          photoList: _ctx.state.showPhotoList,
          onCloseModel: _ctx.closeModel
        }, null, 8, ["photoList", "onCloseModel"]))
      : _createCommentVNode("", true)
  ]))
})